import { render, staticRenderFns } from "./AppSidebarTransition.vue?vue&type=template&id=2f4704c1&scoped=true"
import script from "./AppSidebarTransition.vue?vue&type=script&lang=ts"
export * from "./AppSidebarTransition.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebarTransition.vue?vue&type=style&index=0&id=2f4704c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4704c1",
  null
  
)

export default component.exports